import { trimSpacesStringUtil } from 'utils/string/trim-spaces'

export default function sanitizeSrcImageUtil (src) {
  if (!src) {
    return ''
  }
  return trimSpacesStringUtil(src.replace(
    /(https:)?\/\/cdn\.gymaholic\.co/,
    ''
  ))
}
